require('/opt/odin/app/frontend/components/offers/discount_tag/index.module.scss');module.exports = "../../app/cells/components/offers/discount_tag/show.erb";